<template>

<div class="not-found">

    <h1>There is no such project!</h1>

    <router-link to="/" class="btn">Back to home</router-link>

</div>

</template>

<script>
import { EventBus } from '@/main'

export default {

    beforeRouteLeave(to, from, next) {

        EventBus.$emit('isSingle', false)
        next()
    }
}

</script>



// WEBPACK FOOTER //
// NotFound.vue?6850de81